var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-contain" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动时间", prop: "daterange" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                    },
                    model: {
                      value: _vm.daterange,
                      callback: function ($$v) {
                        _vm.daterange = $$v
                      },
                      expression: "daterange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入名称", clearable: "" },
                    model: {
                      value: _vm.query.event,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "event",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.event",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.query.createAt,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "createAt",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.createAt",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusList, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["prize_edit"],
                          expression: "['prize_edit']",
                        },
                      ],
                      staticClass: "add",
                      staticStyle: { "margin-right": "40px" },
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.addClick },
                    },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.records,
            border: "",
            size: "mini",
            pagination: _vm.pagination,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { label: "活动ID", prop: "id", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "活动名称", prop: "name", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "statusType", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "创建人", prop: "createUser", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", prop: "createTime", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动时间",
              prop: "discountsMoney",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v("活动开始时间:" + _vm._s(scope.row.startTime)),
                    ]),
                    _c("div", [
                      _vm._v("活动结束时间:" + _vm._s(scope.row.endTime)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              prop: "operate",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status !== 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["prize_edit"],
                                expression: "['prize_edit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.getAdvertisingInfo(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    scope.row.status !== 3
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["prize_edit"],
                                expression: "['prize_edit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleSetPrize(scope.row)
                              },
                            },
                          },
                          [_vm._v("奖品设置")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["prize_edit"],
                            expression: "['prize_edit']",
                          },
                        ],
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleStatistics(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("数据")]
                    ),
                    scope.row.isHavePrize
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["prize_edit"],
                                expression: "['prize_edit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleVirtualList(scope.row)
                              },
                            },
                          },
                          [_vm._v("中奖名单")]
                        )
                      : _vm._e(),
                    scope.row.status === 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["prize_edit"],
                                expression: "['prize_edit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.controlsStatus(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("上架")]
                        )
                      : _vm._e(),
                    scope.row.status === 1 || scope.row.status === 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["prize_edit"],
                                expression: "['prize_edit']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.controlsStatus(scope.row, -1)
                              },
                            },
                          },
                          [_vm._v("下架")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("prize-draw-edit", {
            ref: "drawEdit",
            attrs: { visible: _vm.editVisible, formData: _vm.advertisingInfo },
            on: { saveEdit: _vm.saveEdit, closeEdit: _vm.closeEdit },
          })
        : _vm._e(),
      _c("prize-detail", {
        ref: "activityDetail",
        on: { lookActive: _vm.lookActive },
      }),
      _c("prize-draw-look", {
        ref: "prizeLook",
        attrs: { visibleLook: _vm.visibleLook },
        on: { closeLook: _vm.closeLook },
      }),
      _c("prize-statistics", {
        ref: "statistics",
        attrs: { visible: _vm.visibleStatistics, activityId: _vm.activityId },
        on: { close: _vm.closeStatistics },
      }),
      _c("set-prize", {
        ref: "setPrize",
        attrs: {
          visible: _vm.visibleSetPrize,
          activityId: _vm.activityId,
          activeStatus: _vm.activeStatus,
        },
        on: { close: _vm.closeSetPrize },
      }),
      _c(
        "YdDialog",
        {
          attrs: {
            title: "中奖名单",
            visible: _vm.showRollCall,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRollCall = $event
            },
            close: _vm.closeRollCall,
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "中奖名单" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.fakeWinnerListToggle,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fakeWinnerListToggle", $$v)
                        },
                        expression: "form.fakeWinnerListToggle",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("展示")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("隐藏")]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex flex-align-center margin-top-10" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            icon: "el-icon-plus",
                            plain: "",
                            disabled: _vm.form.fakeWinnerListToggle == 2,
                            size: "mini",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.controlsPrize("add")
                            },
                          },
                        },
                        [_vm._v("新增虚拟中奖数据")]
                      ),
                      _c("span", { staticClass: "margin-left-15 font-12" }, [
                        _vm._v("完成活动奖品配置后操作添加虚拟中奖数据"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    _vm._l(_vm.virtualList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass:
                            "flex flex-align-center font-12 margin-top-10",
                        },
                        [
                          _c("div", { staticClass: "margin-right-15" }, [
                            _vm._v("记录" + _vm._s(index + 1) + "："),
                          ]),
                          _c("div", [_vm._v("用户手机号：")]),
                          _c("el-input", {
                            staticClass: "margin-right-15",
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入手机号",
                              size: "mini",
                              maxlength: 11,
                            },
                            model: {
                              value: item.userPhone,
                              callback: function ($$v) {
                                _vm.$set(
                                  item,
                                  "userPhone",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "item.userPhone",
                            },
                          }),
                          _c("div", [_vm._v("中奖奖品：")]),
                          _c(
                            "el-select",
                            {
                              staticClass: "margin-right-15",
                              attrs: {
                                size: "mini",
                                placeholder: "请选择奖品",
                              },
                              model: {
                                value: item.prizesId,
                                callback: function ($$v) {
                                  _vm.$set(item, "prizesId", $$v)
                                },
                                expression: "item.prizesId",
                              },
                            },
                            _vm._l(_vm.prizeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.controlsPrize("del", index)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeRollCall } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saveLoading },
                  on: { click: _vm.saveRollCall },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }